// Wspólna ocena „czy agent on-prem jest na żywo".
// v2 nie ma socket.io — żywotność liczymy ze świeżości heartbeatu (last_seen_at),
// nie z (nieistniejącego) połączenia socket. Agent pobiera zadania w kilka sekund,
// więc heartbeatuje często; 2 min daje margines na pojedynczy pominięty beat.
export const AGENT_ONLINE_WINDOW_MS = 2 * 60_000;

export interface AgentLike {
  status?: string | null;
  last_seen_at?: string | null;
}

/** Agent jest „online" gdy jest aktywny (zarejestrowany) ORAZ heartbeatował niedawno. */
export function isAgentOnline(a: AgentLike | null | undefined): boolean {
  if (!a || a.status !== 'active' || !a.last_seen_at) return false;
  const seen = new Date(a.last_seen_at).getTime();
  return Number.isFinite(seen) && Date.now() - seen < AGENT_ONLINE_WINDOW_MS;
}
